export enum NavigationPath {
  AccommodationSelectionStep = '/',
  ImprovementStep = '/wybor-ulepszen/:token/',
  SummaryStep = '/podsumowanie-rezerwacji/:token/',
  NotFound = '/404/',
}
